import { useCallback } from 'react';
import type { Locale } from './strings';
import { useI18n } from './I18nContext';

export function getLocaleFromPathname(pathname: string): Locale {
  return pathname === '/es' || pathname.startsWith('/es/') ? 'es' : 'en';
}

export function stripLocalePrefix(pathname: string): string {
  if (pathname === '/es') return '/';
  if (pathname.startsWith('/es/')) return pathname.slice(3);
  return pathname;
}

export function localizePath(pathname: string, locale: Locale): string {
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const stripped = stripLocalePrefix(normalized);

  if (locale === 'es') {
    return stripped === '/' ? '/es' : `/es${stripped}`;
  }

  return stripped;
}

export function toggleLocalePathname(pathname: string, nextLocale: Locale): string {
  const stripped = stripLocalePrefix(pathname);
  return localizePath(stripped, nextLocale);
}

export function useLocalizedPath() {
  const { locale } = useI18n();

  return useCallback((pathname: string) => localizePath(pathname, locale), [locale]);
}
